var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.userPermissions.indexOf("access_social_media_calendar") > -1
        ? [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "internal-page-main-section contact-page-main col-12 social-media-calendar-container"
              },
              [
                _c("div", { staticClass: "container" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.swipViews == 2,
                          expression: "swipViews == 2"
                        }
                      ]
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "social-media-calendar bottom-employee-detail col-12 float-l"
                        },
                        [
                          _c("div", {}, [
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "color-red heading-text-24 line-height-28 font-text-semi-medium-mont float-l width-full"
                              },
                              [
                                _vm._v(" " + _vm._s(_vm.formTitle) + " "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary pull-right",
                                    attrs: { type: "submit" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.buttonBack(2)
                                      }
                                    }
                                  },
                                  [_vm._v("Back")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", {}, [
                              _c(
                                "form",
                                { attrs: { id: "socialMediaForm" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-lg-12 col-md-12 col-sm-12 col-12"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _vm._m(1),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.title,
                                                expression: "title"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              id: "title",
                                              placeholder: "Title"
                                            },
                                            domProps: { value: _vm.title },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.title = $event.target.value
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "font",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(_vm.titleError))]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-lg-12 col-md-12 col-sm-12 col-12"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _vm._m(2),
                                          _vm._v(" "),
                                          _c("textarea", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.description,
                                                expression: "description"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              id: "description",
                                              maxlength: _vm.charLimit,
                                              placeholder: "Description"
                                            },
                                            domProps: {
                                              value: _vm.description
                                            },
                                            on: {
                                              keyup: function($event) {
                                                return _vm.charCount()
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.description =
                                                  $event.target.value
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "font",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.descriptionError)
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-lg-12 col-md-12 col-sm-12 col-12"
                                    },
                                    [
                                      _c("div", { staticClass: "form-group" }, [
                                        _c(
                                          "label",
                                          { attrs: { for: "hashTag" } },
                                          [_vm._v("Hash Tags")]
                                        ),
                                        _vm._v(" "),
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.hashTag,
                                              expression: "hashTag"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            id: "hashTag",
                                            placeholder: "Hash Tags"
                                          },
                                          domProps: { value: _vm.hashTag },
                                          on: {
                                            keyup: function($event) {
                                              return _vm.charCount()
                                            },
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.hashTag = $event.target.value
                                            }
                                          }
                                        })
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "float-r" },
                                    [
                                      _c(
                                        "font",
                                        { staticClass: "text-danger" },
                                        [_vm._v(_vm._s(_vm.charCountError))]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "float-l" },
                                    [
                                      _c(
                                        "font",
                                        { staticClass: "text-danger" },
                                        [_vm._v(_vm._s(_vm.charLimitError))]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-lg-12 col-md-12 col-sm-12 col-12"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c(
                                            "label",
                                            { attrs: { for: "dropzone" } },
                                            [_vm._v("Attachments")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "vue-dropzone",
                                            {
                                              ref: "dropzone",
                                              attrs: {
                                                id: "dropzone",
                                                options: _vm.dropzoneOptions,
                                                useCustomSlot: true
                                              },
                                              on: {
                                                "vdropzone-success":
                                                  _vm.uploadDocument,
                                                "vdropzone-processing":
                                                  _vm.disableButtons,
                                                "vdropzone-processing-multiple":
                                                  _vm.disableButtons,
                                                "vdropzone-removed-file":
                                                  _vm.removedSelectedFile,
                                                "vdropzone-error":
                                                  _vm.fileError,
                                                "vdropzone-file-added":
                                                  _vm.fileAdd,
                                                "vdropzone-queue-complete":
                                                  _vm.fileUploadProcessDone
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "dropzone-custom-content"
                                                },
                                                [
                                                  _c(
                                                    "h4",
                                                    {
                                                      staticClass:
                                                        "dropzone-custom-title"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Drop files here or click to upload."
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "subtitle" },
                                                    [
                                                      _vm._v(
                                                        "(Select files from your computer.)"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "float-r" },
                                    [
                                      _c(
                                        "font",
                                        { staticClass: "text-danger" },
                                        [_vm._v(_vm._s(_vm.filesCountError))]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "clearfix" }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "StartDate col-lg-6 col-md-6 col-sm-12 col-12"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c(
                                            "label",
                                            {
                                              attrs: {
                                                slot: "before",
                                                for: "startDate"
                                              },
                                              slot: "before"
                                            },
                                            [
                                              _vm._v("Post Date"),
                                              _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [_vm._v("*")]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("datePicker", {
                                            attrs: {
                                              id: "StartDate",
                                              config: _vm.optionsStart
                                            },
                                            on: {
                                              "dp-change": function($event) {
                                                return _vm.changeStartDt()
                                              }
                                            },
                                            model: {
                                              value: _vm.startDateForm,
                                              callback: function($$v) {
                                                _vm.startDateForm = $$v
                                              },
                                              expression: "startDateForm"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "font",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(_vm.startDateError))]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "StartDate col-lg-6 col-md-6 col-sm-12 col-12"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c(
                                            "label",
                                            {
                                              attrs: {
                                                slot: "before",
                                                for: "StartTime"
                                              },
                                              slot: "before"
                                            },
                                            [_vm._v("Post Time")]
                                          ),
                                          _vm._v(" "),
                                          _c("datePicker", {
                                            attrs: {
                                              id: "StartTime",
                                              config: _vm.optionsTime
                                            },
                                            on: {
                                              "dp-change": function($event) {
                                                return _vm.changeTimeDt()
                                              }
                                            },
                                            model: {
                                              value: _vm.startTimeForm,
                                              callback: function($$v) {
                                                _vm.startTimeForm = $$v
                                              },
                                              expression: "startTimeForm"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "font",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(_vm.StartTimeError))]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "clearfix" }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-lg-6 col-md-6 col-sm-12 col-12"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _vm._m(3),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.userId,
                                                expression: "userId"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              id: "userId",
                                              placeholder: "Contact Person"
                                            },
                                            domProps: { value: _vm.userId },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.userId = $event.target.value
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "font",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.contactPersonError)
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-lg-6 col-md-6 col-sm-12 col-12"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _vm._m(4),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.contactEmail,
                                                expression: "contactEmail"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              id: "contactEmail",
                                              placeholder: "Contact Email"
                                            },
                                            domProps: {
                                              value: _vm.contactEmail
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.contactEmail =
                                                  $event.target.value
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "font",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.contactEmailError)
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "clearfix" }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-lg-6 col-md-6 col-sm-12 col-12"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c(
                                            "label",
                                            { attrs: { for: "contactNumber" } },
                                            [_vm._v("Contact Number")]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.contactNumber,
                                                expression: "contactNumber"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              id: "contactNumber",
                                              placeholder: "Contact Number"
                                            },
                                            domProps: {
                                              value: _vm.contactNumber
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.contactNumber =
                                                  $event.target.value
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "font",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.contactNumberError)
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.editEventID != 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-lg-6 col-md-6 col-sm-12 col-12"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "form-group" },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for: "createdByUserName"
                                                  }
                                                },
                                                [_vm._v("Created By")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    id: "createdByUserName"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.createdByUserName
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-lg-6 col-md-6 col-sm-12 col-12"
                                    },
                                    [
                                      _c("div", { staticClass: "form-group" }, [
                                        _c(
                                          "label",
                                          { attrs: { for: "createdBy" } },
                                          [_vm._v(_vm._s(_vm.createdByTitle))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "form-control",
                                            attrs: { id: "createdBy" }
                                          },
                                          [_vm._v(_vm._s(_vm.createdBy))]
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.editEventID != 0 && _vm.is_approved != 2
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-lg-6 col-md-6 col-sm-12 col-12"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _vm.is_approved == 1
                                                  ? [
                                                      _c(
                                                        "label",
                                                        {
                                                          attrs: {
                                                            for:
                                                              "approvedByUserName"
                                                          }
                                                        },
                                                        [_vm._v("Approved By")]
                                                      )
                                                    ]
                                                  : [
                                                      _c(
                                                        "label",
                                                        {
                                                          attrs: {
                                                            for:
                                                              "approvedByUserName"
                                                          }
                                                        },
                                                        [_vm._v("Denied By")]
                                                      )
                                                    ],
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      id: "approvedByUserName"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.approvedByUserName
                                                      )
                                                    )
                                                  ]
                                                )
                                              ],
                                              2
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-lg-6 col-md-6 col-sm-12 col-12"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _vm.is_approved == 1
                                                  ? [
                                                      _c(
                                                        "label",
                                                        {
                                                          attrs: {
                                                            for:
                                                              "approvedByTime"
                                                          }
                                                        },
                                                        [_vm._v("Approved At")]
                                                      )
                                                    ]
                                                  : [
                                                      _c(
                                                        "label",
                                                        {
                                                          attrs: {
                                                            for:
                                                              "approvedByTime"
                                                          }
                                                        },
                                                        [_vm._v("Denied At")]
                                                      )
                                                    ],
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      id: "approvedByTime"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.approvedByTime)
                                                    )
                                                  ]
                                                )
                                              ],
                                              2
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "clearfix" }),
                                  _vm._v(" "),
                                  _vm._m(5),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "clearfix" }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row clearfix" }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 col-sm-12 col-md-12 col-lg-12"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "button-demo" },
                                        [
                                          _c("input", {
                                            staticClass:
                                              "btn btn-primary pull-right",
                                            attrs: {
                                              id: "CancelSocialMedia",
                                              type: "submit",
                                              value: "Cancel"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.buttonBack(2)
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("input", {
                                            staticClass:
                                              "mr-1 btn btn-primary pull-right",
                                            attrs: {
                                              id: "addSocialMediaBtn",
                                              type: "submit",
                                              value: "Save"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.addEvent("post")
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm.userPermissions.indexOf(
                                            "manage_social_media_calendar_events"
                                          ) > -1
                                            ? [
                                                _vm.selected.is_approved == 1 ||
                                                _vm.selected.is_approved == 2
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-primary pull-right mr-1",
                                                        attrs: {
                                                          type: "button",
                                                          id: "deniedEvent"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.checkEventForApproval(
                                                              _vm.editEventID,
                                                              "deny"
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-times",
                                                          attrs: {
                                                            "aria-hidden":
                                                              "true"
                                                          }
                                                        }),
                                                        _vm._v(" DENY")
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.selected.is_approved == 0 ||
                                                _vm.selected.is_approved == 2
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-primary pull-right mr-1",
                                                        attrs: {
                                                          type: "button",
                                                          id: "approvedEvent"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.checkEventForApproval(
                                                              _vm.editEventID,
                                                              "approve"
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-check",
                                                          attrs: {
                                                            "aria-hidden":
                                                              "true"
                                                          }
                                                        }),
                                                        _vm._v(" APPROVE")
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ],
                                2
                              )
                            ])
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.swipViews == 1,
                          expression: "swipViews == 1"
                        }
                      ]
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "social-media-calendar bottom-employee-detail col-12 float-l"
                        },
                        [
                          _c(
                            "div",
                            {},
                            [
                              _c(
                                "h2",
                                {
                                  staticClass:
                                    "color-red heading-text-24 line-height-28 font-text-semi-medium-mont float-l width-full textOverFlow"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.selected.title) +
                                      "\n                                "
                                  ),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary pull-right",
                                      attrs: { type: "submit" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.buttonBack(0)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-chevron-left",
                                        attrs: { "aria-hidden": "true" }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.roleId <= 1 ||
                                            _vm.userPermissions.indexOf(
                                              "post_social_media"
                                            ) > -1 ||
                                            _vm.userPermissions.indexOf(
                                              "draft_social_media"
                                            ) > -1,
                                          expression:
                                            "roleId <= 1 || userPermissions.indexOf('post_social_media') > -1 || userPermissions.indexOf('draft_social_media') > -1"
                                        }
                                      ],
                                      staticClass:
                                        "mr-1 btn btn-primary pull-right",
                                      attrs: { type: "submit" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.editEvent(
                                            _vm.selected.id,
                                            false
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-pencil",
                                        attrs: { "aria-hidden": "true" }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.roleId <= 1 ||
                                            _vm.userPermissions.indexOf(
                                              "post_social_media"
                                            ) > -1 ||
                                            _vm.userPermissions.indexOf(
                                              "draft_social_media"
                                            ) > -1,
                                          expression:
                                            "roleId <= 1 || userPermissions.indexOf('post_social_media') > -1 || userPermissions.indexOf('draft_social_media') > -1"
                                        }
                                      ],
                                      staticClass:
                                        "mr-1 btn btn-primary pull-right",
                                      attrs: { type: "submit" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.deleteEvents(
                                            _vm.selected.id
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-trash",
                                        attrs: { "aria-hidden": "true" }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.roleId <= 1 ||
                                            _vm.userPermissions.indexOf(
                                              "post_social_media"
                                            ) > -1 ||
                                            _vm.userPermissions.indexOf(
                                              "draft_social_media"
                                            ) > -1,
                                          expression:
                                            "roleId <= 1 || userPermissions.indexOf('post_social_media') > -1 || userPermissions.indexOf('draft_social_media') > -1"
                                        }
                                      ],
                                      staticClass:
                                        "mr-1 btn btn-primary pull-right",
                                      attrs: { type: "submit" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.editEvent(
                                            _vm.selected.id,
                                            true
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-retweet",
                                        attrs: { "aria-hidden": "true" }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.userPermissions.indexOf(
                                    "manage_social_media_calendar_events"
                                  ) > -1
                                    ? [
                                        _vm.selected.is_approved == 1 ||
                                        _vm.selected.is_approved == 2
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-primary pull-right mr-1",
                                                attrs: {
                                                  type: "button",
                                                  id: "deniedEvent"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.checkEventForApproval(
                                                      _vm.selected.id,
                                                      "deny"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-times",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                }),
                                                _vm._v(" DENY")
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.selected.is_approved == 0 ||
                                        _vm.selected.is_approved == 2
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-primary pull-right mr-1",
                                                attrs: {
                                                  type: "button",
                                                  id: "approvedEvent"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.checkEventForApproval(
                                                      _vm.selected.id,
                                                      "approve"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-check",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                }),
                                                _vm._v(" APPROVE")
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    : _vm._e()
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("div", {}, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      " bottom-employee-detail-left col-12 col-sm-6 col-md-6 col-lg-6"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "bg-color-table mt-20 float-l width-full"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "bus-detail-row width-full float-l"
                                          },
                                          [
                                            _vm._m(6),
                                            _vm._v(" "),
                                            _vm._m(7),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-inner-detail col-number colpie-60 float-l"
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "color-blue heading-text-14 line-height-18"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.selected
                                                            .contact_person
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "bus-detail-row width-full float-l"
                                          },
                                          [
                                            _vm._m(8),
                                            _vm._v(" "),
                                            _vm._m(9),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-inner-detail col-number colpie-60 float-l"
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "color-blue heading-text-14 line-height-18"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.selected
                                                            .contact_email
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.selected.contact_number != ""
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "bus-detail-row width-full float-l"
                                                },
                                                [
                                                  _vm._m(10),
                                                  _vm._v(" "),
                                                  _vm._m(11),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-inner-detail col-number colpie-60 float-l"
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "color-blue heading-text-14 line-height-18"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.selected
                                                                  .contact_number
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "bottom-employee-detail-right col-12 col-sm-6 col-md-6 col-lg-6"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "bg-color-table mt-20 float-l width-full"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "bus-detail-row width-full float-l"
                                          },
                                          [
                                            _vm._m(12),
                                            _vm._v(" "),
                                            _vm._m(13),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-inner-detail col-number colpie-60 float-l"
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "color-blue heading-text-14 line-height-18"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.selected
                                                            .display_date
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "bus-detail-row width-full float-l "
                                          },
                                          [
                                            _vm._m(14),
                                            _vm._v(" "),
                                            _vm._m(15),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-inner-detail col-number colpie-60 float-l"
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "color-blue heading-text-14 line-height-18 textOverFlow"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.selected.has_tags
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      " bottom-employee-detail-left col-12 col-sm-6 col-md-6 col-lg-6"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "bg-color-table mt-20 float-l width-full"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "bus-detail-row width-full float-l"
                                          },
                                          [
                                            _vm._m(16),
                                            _vm._v(" "),
                                            _vm._m(17),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-inner-detail col-number colpie-60 float-l"
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "color-blue heading-text-14 line-height-18"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.selected
                                                            .created_first_name
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.selected
                                                            .created_last_name
                                                        )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.selected.is_approved != 2
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "bus-detail-row width-full float-l"
                                              },
                                              [
                                                _vm._m(18),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-inner-detail col-area border-rt-white colpie-32 float-l"
                                                  },
                                                  [
                                                    _vm.selected.is_approved ==
                                                    1
                                                      ? [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "color-333333 heading-text-14 line-height-18"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Approved By "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      : [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "color-333333 heading-text-14 line-height-18"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Denied By "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-inner-detail col-number colpie-60 float-l"
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "color-blue heading-text-14 line-height-18"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.selected
                                                                .approved_by
                                                            )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "bottom-employee-detail-right col-12 col-sm-6 col-md-6 col-lg-6"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "bg-color-table mt-20 float-l width-full"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "bus-detail-row width-full float-l"
                                          },
                                          [
                                            _vm._m(19),
                                            _vm._v(" "),
                                            _vm._m(20),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-inner-detail col-number colpie-60 float-l"
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "color-blue heading-text-14 line-height-18"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.selected
                                                            .created_at
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.selected.is_approved != 2
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "bus-detail-row width-full float-l"
                                              },
                                              [
                                                _vm._m(21),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-inner-detail col-area border-rt-white colpie-32 float-l"
                                                  },
                                                  [
                                                    _vm.selected.is_approved ==
                                                    1
                                                      ? [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "color-333333 heading-text-14 line-height-18"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Approved At "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      : [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "color-333333 heading-text-14 line-height-18"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Denied At "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-inner-detail col-number colpie-60 float-l"
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "color-blue heading-text-14 line-height-18"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.selected
                                                                .approved_by_action_time
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "h2",
                                {
                                  staticClass:
                                    "mt-14 heading-text-18 line-height-18 font-text-semi-medium-mont float-l width-full"
                                },
                                [_vm._v(" Description ")]
                              ),
                              _vm._v(" "),
                              _c("div", {}, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-12 col-sm-12 col-md-12 col-lg-12"
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "social-media-description bg-color-table mt-20 mb-20 float-l width-full textOverFlow",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.selected.description
                                        )
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _vm.selectedAttachments > 0
                                ? [
                                    _c(
                                      "h2",
                                      {
                                        staticClass:
                                          "mt-14 heading-text-18 line-height-18 font-text-semi-medium-mont float-l width-full"
                                      },
                                      [
                                        _vm._v(" Attachments "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary pull-right",
                                            attrs: {
                                              type: "button",
                                              id: "DownloadAll"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.downloadAllAttachments(
                                                  _vm.selected.id
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("Download All")]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {}, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 col-sm-12 col-md-12 col-lg-12"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "social-media-description bg-color-table mt-20 mb-20 float-l width-full"
                                            },
                                            [
                                              [
                                                _c(
                                                  "swiper",
                                                  {
                                                    ref: "swiperAttachment",
                                                    attrs: {
                                                      options:
                                                        _vm.swiperOptionAttachments
                                                    }
                                                  },
                                                  [
                                                    _vm._l(
                                                      _vm.selected.attachments,
                                                      function(doc, index1) {
                                                        return [
                                                          doc.type.toLowerCase() ==
                                                          "image"
                                                            ? [
                                                                _c(
                                                                  "swiper-slide",
                                                                  [
                                                                    _c("img", {
                                                                      attrs: {
                                                                        src:
                                                                          doc.url
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.openGallery(
                                                                            _vm
                                                                              .selected
                                                                              .attachments,
                                                                            index1
                                                                          )
                                                                        }
                                                                      }
                                                                    })
                                                                  ]
                                                                )
                                                              ]
                                                            : doc.type.toLowerCase() ==
                                                              "video"
                                                            ? [
                                                                _c(
                                                                  "swiper-slide",
                                                                  [
                                                                    _c("img", {
                                                                      staticClass:
                                                                        "link-icon",
                                                                      attrs: {
                                                                        src:
                                                                          "/static/images/video-icon.png"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.downloadImage(
                                                                            doc.url
                                                                          )
                                                                        }
                                                                      }
                                                                    })
                                                                  ]
                                                                )
                                                              ]
                                                            : doc.extension.toLowerCase() ==
                                                                "doc" ||
                                                              doc.extension.toLowerCase() ==
                                                                "docx"
                                                            ? [
                                                                _c(
                                                                  "swiper-slide",
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href:
                                                                            "#",
                                                                          id:
                                                                            "id" +
                                                                            index1
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.getSignedUrlPath(
                                                                              doc.url
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "img",
                                                                          {
                                                                            staticClass:
                                                                              "link-icon",
                                                                            attrs: {
                                                                              src:
                                                                                "/static/images/doc-icon.png"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            : doc.extension.toLowerCase() ==
                                                                "xls" ||
                                                              doc.extension.toLowerCase() ==
                                                                "xlsx"
                                                            ? [
                                                                _c(
                                                                  "swiper-slide",
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href:
                                                                            "#",
                                                                          id:
                                                                            "id" +
                                                                            index1
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.getSignedUrlPath(
                                                                              doc.url
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "img",
                                                                          {
                                                                            staticClass:
                                                                              "link-icon",
                                                                            attrs: {
                                                                              src:
                                                                                "/static/images/xl-icon.png"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            : doc.extension.toLowerCase() ==
                                                                "ppt" ||
                                                              doc.extension.toLowerCase() ==
                                                                "pptx"
                                                            ? [
                                                                _c(
                                                                  "swiper-slide",
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href:
                                                                            "#",
                                                                          id:
                                                                            "id" +
                                                                            index1
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.getSignedUrlPath(
                                                                              doc.url
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "img",
                                                                          {
                                                                            staticClass:
                                                                              "link-icon",
                                                                            attrs: {
                                                                              src:
                                                                                "/static/images/ppt-icon.png"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            : doc.extension.toLowerCase() ==
                                                              "pdf"
                                                            ? [
                                                                _c(
                                                                  "swiper-slide",
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href:
                                                                            "#",
                                                                          id:
                                                                            "id" +
                                                                            index1
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.getSignedUrlPath(
                                                                              doc.url
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "img",
                                                                          {
                                                                            staticClass:
                                                                              "link-icon",
                                                                            attrs: {
                                                                              src:
                                                                                "/static/images/pdf-icon.png"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            : [
                                                                _c(
                                                                  "swiper-slide",
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href:
                                                                            "#",
                                                                          id:
                                                                            "id" +
                                                                            index1
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.getSignedUrlPath(
                                                                              doc.url
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "img",
                                                                          {
                                                                            staticClass:
                                                                              "link-icon",
                                                                            attrs: {
                                                                              src:
                                                                                "/static/images/link-icon.png"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                        ]
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              ]
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.swipViews == 0,
                          expression: "swipViews == 0"
                        }
                      ],
                      staticClass: "row"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 col-sm-12 col-md-12 col-lg-12 b-25 calendar-main-section"
                        },
                        [
                          _c("div", { staticClass: "nevCalendar" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success pull-left",
                                staticStyle: {
                                  "margin-left": "5px",
                                  padding: "9px 12px"
                                },
                                attrs: { id: "" },
                                on: { click: _vm.previousMonth }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-chevron-left",
                                  attrs: { "aria-hidden": "true" }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success pull-left",
                                staticStyle: {
                                  "margin-left": "5px",
                                  padding: "9px 12px"
                                },
                                attrs: { id: "" },
                                on: { click: _vm.nextMonth }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-chevron-right",
                                  attrs: { "aria-hidden": "true" }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-success pull-right",
                              staticStyle: {
                                "margin-left": "5px",
                                padding: "9px 12px"
                              },
                              attrs: { id: "refresh" },
                              on: { click: _vm.refreshEvents }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-refresh",
                                attrs: { "aria-hidden": "true" }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(22),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-info btn-lg",
                              staticStyle: { display: "none" },
                              attrs: {
                                type: "button",
                                id: "openModel",
                                "data-toggle": "modal",
                                "data-target": "#myModal"
                              }
                            },
                            [_vm._v("Open Modal")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "btn btn-success form-group pull-right searchBtn",
                              attrs: { id: "search" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.searchEvents,
                                    expression: "searchEvents"
                                  }
                                ],
                                staticClass: "form-control searchInput",
                                attrs: { type: "text", placeholder: "Search" },
                                domProps: { value: _vm.searchEvents },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.searchEvents = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm._m(23)
                            ]
                          ),
                          _vm._v(" "),
                          _c("full-calendar", {
                            ref: "calendar",
                            attrs: {
                              id: "SMcalendar",
                              events: _vm.events,
                              config: _vm.config
                            },
                            on: {
                              "day-click": _vm.dayClick,
                              "event-selected": _vm.eventSelected
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "list-group",
                              attrs: { id: "list" }
                            },
                            [
                              _vm._l(_vm.eventList, function(text, index) {
                                return [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "list-group-item list-group-item-action",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.loadEvent(text.id)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(_vm._s(text.title)),
                                      _c(
                                        "span",
                                        { staticClass: "pull-right" },
                                        [_vm._v(_vm._s(text.display_date))]
                                      )
                                    ]
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "modal fade socialmediacalendarpopup",
                attrs: { id: "myModal", role: "dialog" }
              },
              [
                _c("div", { staticClass: "modal-dialog modal-lg" }, [
                  _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-body" }, [
                      _c("img", {
                        staticClass: "w-100 mb-3",
                        attrs: { src: _vm.viewImage }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "ml-2 btn btn-primary pull-right themebutton",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.changeImage("previous")
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-angle-left",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "ml-2 btn btn-primary pull-right themebutton",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.changeImage("next")
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-angle-right",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "ml-2 btn btn-primary pull-right themebutton",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.downloadImage(_vm.viewImage)
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-download",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      )
                    ])
                  ])
                ])
              ]
            )
          ]
        : [_vm._m(24), _vm._v(" "), _vm._m(25)]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "internal-page-banner-main col-12" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "page-title" }, [
            _c("h1", [_vm._v(" Social Media Calendar ")])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "title" } }, [
      _vm._v("Title"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "description" } }, [
      _vm._v("Description"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "userId" } }, [
      _vm._v("Contact Person"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "contactEmail" } }, [
      _vm._v("Contact Email"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row clearfix" }, [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12 col-12" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
      },
      [_c("p", { staticClass: "small-bullet center" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail col-area border-rt-white colpie-32 float-l"
      },
      [
        _c(
          "p",
          { staticClass: "color-333333 heading-text-14 line-height-18" },
          [_vm._v(" Contact Person ")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
      },
      [_c("p", { staticClass: "small-bullet center" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail col-area border-rt-white colpie-32 float-l"
      },
      [
        _c(
          "p",
          { staticClass: "color-333333 heading-text-14 line-height-18" },
          [_vm._v(" Contact Email ")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
      },
      [_c("p", { staticClass: "small-bullet center" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail col-area border-rt-white colpie-32 float-l"
      },
      [
        _c(
          "p",
          { staticClass: "color-333333 heading-text-14 line-height-18" },
          [_vm._v(" Contact Number ")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
      },
      [_c("p", { staticClass: "small-bullet center" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail col-area border-rt-white colpie-32 float-l"
      },
      [
        _c(
          "p",
          { staticClass: "color-333333 heading-text-14 line-height-18" },
          [_vm._v(" Date ")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
      },
      [_c("p", { staticClass: "small-bullet center" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail col-area border-rt-white colpie-32 float-l"
      },
      [
        _c(
          "p",
          { staticClass: "color-333333 heading-text-14 line-height-18" },
          [_vm._v(" Hash Tags ")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
      },
      [_c("p", { staticClass: "small-bullet center" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail col-area border-rt-white colpie-32 float-l"
      },
      [
        _c(
          "p",
          { staticClass: "color-333333 heading-text-14 line-height-18" },
          [_vm._v(" Created By ")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
      },
      [_c("p", { staticClass: "small-bullet center" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
      },
      [_c("p", { staticClass: "small-bullet center" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail col-area border-rt-white colpie-32 float-l"
      },
      [
        _c(
          "p",
          { staticClass: "color-333333 heading-text-14 line-height-18" },
          [_vm._v(" Created At ")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-inner-detail inner-first-row border-rt-white colpie-8 float-l"
      },
      [_c("p", { staticClass: "small-bullet center" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-success pull-right",
        staticStyle: { "margin-left": "5px", padding: "9px 12px" },
        attrs: { id: "backToCalendar" }
      },
      [
        _c("i", {
          staticClass: "fa fa-arrow-right",
          attrs: { "aria-hidden": "true" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "search-label" }, [
      _c("i", { staticClass: "fa fa-search" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "internal-page-banner-main col-12" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "page-title" }, [
            _c("h1", [_vm._v(" Oops! ")])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "internal-page-main-section contact-page-main col-12" },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "container" }, [
            _c(
              "div",
              {
                staticClass:
                  "social-media-calendar bottom-employee-detail col-12 float-l"
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "h2",
                    {
                      staticClass:
                        "color-red heading-text-24 line-height-28 font-text-semi-medium-mont float-l width-full"
                    },
                    [_vm._v(" 403 ")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "bottom-employee-detail-left col-12 col-sm-6 col-md-6 col-lg-6"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "bg-color-table mt-20 mb-40 float-l width-full"
                          },
                          [
                            _vm._v(
                              "\n                                        Sorry!, You don't have permission to access this page.\n                                    "
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ])
              ]
            )
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-84163f56", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84163f56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SocialMediaCalendar.vue
// module id = null
// module chunks = 